/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { array, bool, string } from 'prop-types';

const useStyle = makeStyles((theme) => ({
    addonHeading: {
        color: '#000',
        fontFamily: 'Area Variable',
        fontSize: 'var(--fontSizes-fontHeader5DT, 20px)',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'var(--lineHeights-lineHeader5DT, 25px)',
        letterSpacing: '0.2px',
    },
    subHeaddingAddon: {
        color: 'var(--ENT-gray-700, #434343)',
        fontFamily: 'Area Variable',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '22px',
        letterSpacing: '0.14px',
        marginTop: '12px',
    },
}));

const PDPAddonMessage = ({
    pdpContent, isZipVaild,
}) => {
    const classes = useStyle();
    return (
        <div className={classes.addonContainer}>
            <div className={classes.addonHeading}>
                {pdpContent?.entries?.[0]?.add_on_heading_copy || 'Make your gift extra special'}
            </div>
            <div className={classes.subHeaddingAddon}>
                {isZipVaild ? 'Enter a ZIP code to see available extras' : 'Add-ons are not available in this ZIP code'}
            </div>
        </div>
    );
};
PDPAddonMessage.propTypes = {
    pdpContent: array.isRequired,
    isZipVaild: bool,
};
PDPAddonMessage.defaultProps = {
    isZipVaild: false,
};
export default PDPAddonMessage;
